import { bookingAppointmentSchema, operationsAppointmentSchema } from "./appointment_schemas";

const SCHEMA_REGISTRY = {
  "booking-appointment": bookingAppointmentSchema,
  "operations-appointment": operationsAppointmentSchema,
};

export function getSchema(name) {
  const schema = SCHEMA_REGISTRY[name];
  if (!schema) {
    console.error(`[form-validation] Unknown schema: "${name}"`);
  }
  return schema;
}
